/**
 * @author mrdoob / http://mrdoob.com/
 */

import UI from './libs/ui'
var TabHeader = function (editor) {

    var signals = editor.signals;

    var container = new UI.Panel();
    container.setId('tabHeader');
    

    var selected = null;
    var values;

    function build() {

        container.clear();

        if (selected === null) return;

        values = {};
        

        // need to move to sidebar.js > assetSelectorTab

        var row = new UI.Row();
        var editAssetButton = new UI.Button();

        var icon = document.createElement('i')
        icon.className = 'material-icons'
        icon.innerHTML = 'arrow_back_ios'
        editAssetButton.dom.appendChild(icon);
        
       
        editAssetButton.onClick(function(e) {
            if (selected.phase === 'needsAsset') {
                selected.phase = ''
                selected.type = 'Unassigned Node'
                selected.name = 'Unassigned Node'
            }
            else {
                selected.phase = 'needsAsset'
            }
            selected.elements = []
            signals.animationPhaseChanged.dispatch(selected);
            // signals.animationTypeChange.dispatch(animation);
            signals.animationRenamed.dispatch(selected);
            signals.animationModified.dispatch(selected);
        })
        row.add(editAssetButton);

        container.add(row);

    }

    signals.animationSelected.add(function (animation) {

        selected = animation;
        build();
    });

    signals.effectCompiled.add(build);


    return container;

};

export default TabHeader


//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/TabHeader.js
// module id = null
// module chunks = 